import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";

const adminRoutes = [
  "dashboard", "employees", "employee/edit", "employee/register", "login-files", "assigned-files", "query-raised-files", 
  "query-raised-to-bank-files", "completed-files", "settings/profile", 
  "settings/bank-branches", "settings/bank-products", "settings/yaazh-branches",
  "settings/file-format-setup", "settings/file-format-master", "processor-file-view", "create-file",
  "edit-file", "settings/file-format-edit", "settings/file-format-add", 
  "expenses", "expenses/create", "expenses/view", "manage-files", "admin-file-view"
];

const branchAdminRoutes = [
  "dashboard", "login-files", "assigned-files", "query-raised-files",
  "query-raised-to-bank-files", "completed-files", "processor-settings", 
  "edit-file", "processor-file-view", "create-file",
  "expenses", "expenses/create", "expenses/view"
];

const loginOfficerRoutes = [
  "dashboard", "login-files", "assigned-files", "query-raised-files",
  "query-raised-to-bank-files", "completed-files", "processor-settings", 
  "edit-file", "processor-file-view", "create-file",
  "expenses", "expenses/create", "expenses/view"
];

const processorRoutes = [
  "processor-dashboard", "processor-assigned-files", "processor-query-uploaded-files",
  "processor-completed-files", "processor-settings", "processor-file-view",
  "expenses", "expenses/create", "expenses/view"
];

const pvtProcessorRoutes = [
  "processor-dashboard", "login-files", "processor-assigned-files", "processor-query-uploaded-files",
  "processor-completed-files", "processor-settings", "processor-file-view",
  "edit-file", "create-file",
  "expenses", "expenses/create", "expenses/view"
];

const MODExecutiveRoutes = [
  "expenses", "expenses/create", "expenses/view", "processor-settings"
];

const isAuthenticated = () => localStorage.getItem("isLoggedIn") === "true";

export default function PrivateRoute({ children }) {
  const userRole = JSON.parse(localStorage.getItem("user"))?.role;
  const { pathname } = useLocation();

  const pathSegments = pathname.split("/").filter(Boolean);
  const currentRoute = pathSegments.join("/");

  const routeToHome = () => {
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("user");
    return <Navigate to="/" replace />;
  };

  // 🚫 Not logged in
  if (!userRole || !isAuthenticated()) {
    return routeToHome();
  }

  const roleRoutesMap = {
    "Super Admin": adminRoutes,
    "Branch Admin": branchAdminRoutes,
    "Login Officer": loginOfficerRoutes,
    "Processor": processorRoutes,
    "Private Processor": pvtProcessorRoutes,
    "MOD Executive": MODExecutiveRoutes,
  };

  const allowedRoutes = roleRoutesMap[userRole] || [];

  console.log("currentRoute---->", currentRoute)
  // ✅ Check allowed access (exact or nested)
  const isAllowed = allowedRoutes.some(r =>
  currentRoute === r || currentRoute.startsWith(`${r}/`) || currentRoute.match(new RegExp(`^${r}/[0-9]+$`))
);


  return isAllowed ? children : routeToHome();
}
